export default __webpack_public_path__ + "static/media/DavidTanzer-min.de32e483.jpeg";